import { Box, Grid2 as Grid } from "@mui/material"
import SubscriptionAnalytics from "./SubscriptionAnalytics"
import EditCustomPriceCard from "./editCustomPriceCard";

interface RevenueProps {

}

const Revenue: React.FC<RevenueProps> = () => {
  const now = new Date();

  return (
    <Box
      sx={{
        p: {xs: 2, md: 3},
        gap: 3,
        display: 'flex',
        flexDirection: {xs: 'column', lg: 'row'},
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Box
        sx={{
          flex: 1,
        }}
      >
        <EditCustomPriceCard />
      </Box>

      <SubscriptionAnalytics month={now.getMonth()+1} year={now.getFullYear()}/>
    </Box>

  )
}

export default Revenue
